module.exports = __webpack_public_path__ + "img/check.02cce8ec.svg";